<template>
    <div>
        <div v-if="all_sales_leads_loading_satus == true" class="text-center">
            <b-spinner small type="grow"></b-spinner>
            Loading sales leads...
        </div>
        <div v-else>
            <div class="mb-2 d-flex justify-content-end">
                <button type="button" class="btn btn-success mb-2 mr-2" @click="exportToExcel('salesLeadsTable')">
                    <i class="mdi mdi-file-excel mr-1"></i> Export to Excel
                </button>
            </div>
            <webix-ui :config="ui" v-model="all_sales_leads"></webix-ui>
            <div id="salesLeadsTablePaging"></div>
        </div>
    </div>
</template>

<script>
import { crmMethods, crmComputed } from "@/state/helpers";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
    data: () => ({ show_modal_pricing: false }),
    computed: {
        ...crmComputed,
        ui() {
            //eslint-disable-next-line
            let el = this;
            //eslint-disable-next-line
            let ui = {
                id: "salesLeadsTable",
                view: "datatable",
                css: "datatableUsers webix_header_border webix_data_border",
                autoheight: true,
                minHeight: 60,
                scrollY: false,
                scrollX: true,
                resizeColumn: true,
                select: false,
                pager: {
                    template: "{common.prev()} {common.pages()} {common.next()}",
                    container: "salesLeadsTablePaging",
                    size: 20,
                    group: 5,
                },
                columns: [
                    {
                        id: "actions",
                        header: { text: "Actions", css: { "text-align": "center" } },
                        template: function () {
                            return `<div class="tableIcons">
                                <i class="mdi mdi-trash-can deleteAction"></i>
                            </div>`;
                        },
                    },
                    {
                        id: "first_name",
                        header: ["First Name", { content: "textFilter" }],
                        tooltip: false,
                        fillspace: 1,
                        sort: "text",
                    },
                    {
                        id: "last_name",
                        header: ["Last Name", { content: "textFilter" }],
                        tooltip: false,
                        fillspace: 1,
                    },
                    {
                        id: "contact_no",
                        header: ["Contact No", { content: "textFilter" }],
                        tooltip: false,
                        fillspace: 1,
                    },
                    {
                        id: "email",
                        header: ["Email", { content: "textFilter" }],
                        tooltip: false,
                        fillspace: 1,
                    },
                    {
                        id: "province",
                        header: ["Province", { content: "selectFilter" }],
                        tooltip: false,
                        fillspace: 1,
                    },
                    {
                        id: "type",
                        header: ["Type", { content: "selectFilter" }],

                        tooltip: false,
                        fillspace: 1,
                    },
                    {
                        id: "newsletter",
                        header: ["Newsletter", { content: "selectFilter" }],
                        tooltip: false,
                        fillspace: 1,
                    },
                ],
                ready: function () {},
                on: {},
                onClick: {
                    //eslint-disable-next-line
                    viewAction: function (id, e, trg) {
                        let item = this.getItem(e.row);
                        let el = this.$scope.$parent;

                        el.setSelectedRoleForGroupDetails(item);
                        el.showPricingModal();
                    },
                    //eslint-disable-next-line
                    deleteAction: function (id, e, trg) {
                        const el = this.$scope.$parent;
                        const item = this.getItem(e.row);

                        el.handleSwal(item, e);
                    },
                },
            };
            return ui;
        },
    },
    methods: {
        ...crmMethods,
        exportToExcel(id) {
            /* eslint-disable */
            return webix.toExcel($$(id), {
                ignore: { actions: true },
                filename: _.uniqueId("salesLeadsExport_"), // for filename
                name: "Sales Leads", // for sheet name
            });
            /* eslint-enable */
        },
        handleSwal(item) {
            Swal.fire({
                title: `Delete Sales Lead?`,
                text: `${item.first_name}`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, delete!",
            }).then((result) => {
                if (result.value) {
                    this.deleteSalesLead({ id: item.id }).then(() => {
                        Swal.fire("Sales lead deleted", "", "success");

                        this.setAllSalesLeads();
                    });
                }
            });
        },
    },
    mounted() {
        this.setAllSalesLeads();
    },
};
</script>

<style lang="scss">
.pointer {
    cursor: pointer;
}
</style>
